import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import ApplicationForm from '../components/ApplicationForm';

const benefits = ['Free to apply', 'Reviewed in 24–48 hrs', 'Internship guaranteed', 'Placement support'];

export default function ApplyPage() {
  return (
    <div style={{ paddingTop: 70 }}>
      <style>{`
        .apply-hero { background: linear-gradient(135deg, #0f172a, #1e3a5f); padding: 56px 0; text-align: center; }
        .apply-hero h1 { color: white; font-size: clamp(26px, 4vw, 40px); margin-bottom: 10px; }
        .apply-hero p { color: #94a3b8; font-size: 16px; }
        .apply-benefits { display: flex; gap: 20px; justify-content: center; margin-top: 20px; flex-wrap: wrap; }
        .apply-benefit { display: flex; align-items: center; gap: 6px; color: #93c5fd; font-size: 13px; font-weight: 500; }
        .apply-layout { max-width: 920px; margin: 0 auto; padding: 56px 24px; display: grid; grid-template-columns: 1fr 360px; gap: 40px; align-items: start; }
        .apply-form-card { background: white; border-radius: var(--radius-xl); padding: 36px; box-shadow: var(--shadow-md); border: 1px solid var(--border); }
        .apply-form-card h2 { font-size: 22px; margin-bottom: 6px; }
        .apply-form-card p { color: var(--mid); font-size: 14px; margin-bottom: 28px; }
        .apply-side {}
        .apply-steps { background: white; border-radius: var(--radius-xl); padding: 28px; box-shadow: var(--shadow-md); border: 1px solid var(--border); margin-bottom: 20px; }
        .apply-steps h3 { font-size: 16px; margin-bottom: 20px; }
        .apply-step { display: flex; gap: 14px; margin-bottom: 18px; align-items: flex-start; }
        .apply-step-num { width: 28px; height: 28px; border-radius: 50%; background: var(--primary); color: white; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-family: var(--font-display); }
        .apply-step-text h4 { font-size: 14px; font-weight: 600; margin-bottom: 2px; }
        .apply-step-text p { font-size: 12px; color: var(--mid); }
        .apply-guarantee { background: #f0fdf4; border: 1px solid #6ee7b7; border-radius: var(--radius-lg); padding: 20px; }
        .apply-guarantee h4 { color: var(--success); font-size: 15px; margin-bottom: 8px; }
        .apply-guarantee p { font-size: 13px; color: var(--dark-3); line-height: 1.6; }
        @media (max-width: 800px) {
          .apply-layout { grid-template-columns: 1fr; }
          .apply-side { order: -1; }
        }
      `}</style>

      <div className="apply-hero">
        <div className="section-label" style={{ background: 'rgba(26,86,219,0.2)', color: '#93c5fd', margin: '0 auto 14px' }}>Free Application</div>
        <h1>Apply for a Korpnex Program</h1>
        <p>Take the first step towards your tech career. Applications are free and reviewed within 24 hours.</p>
        <div className="apply-benefits">
          {benefits.map((b, i) => <div key={i} className="apply-benefit"><FiCheckCircle size={14} /> {b}</div>)}
        </div>
      </div>

      <div className="apply-layout">
        <div className="apply-form-card">
          <h2>Submit Your Application</h2>
          <p>Fill in your details below. Our admissions team will reach out to you within 24–48 hours.</p>
          <ApplicationForm />
        </div>

        <div className="apply-side">
          <div className="apply-steps">
            <h3>📋 What Happens Next?</h3>
            {[
              { title: 'Submit Application', desc: 'Fill the form — completely free, no payment needed now' },
              { title: 'Application Review', desc: 'Our team reviews your profile within 24–48 hours' },
              { title: 'Approval Email', desc: 'Receive approval with enrollment payment link' },
              { title: 'Pay & Enroll', desc: 'Pay ₹2,000 registration fee to secure your seat' },
              { title: 'Start Learning!', desc: 'Access your dashboard and begin your journey' },
            ].map((s, i) => (
              <div key={i} className="apply-step">
                <div className="apply-step-num">{i + 1}</div>
                <div className="apply-step-text"><h4>{s.title}</h4><p>{s.desc}</p></div>
              </div>
            ))}
          </div>

          <div className="apply-guarantee">
            <h4>🎯 Our Promise</h4>
            <p>Every enrolled student gets a guaranteed internship opportunity and dedicated placement assistance — or we help you until you're placed.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
